/* Casio: precios en bolívares con la tasa BCV del checkout propio de Casio (/pages/checkout, sections/checkout-template).
   Misma URL de tasa, misma caché (localStorage custom_checkout_bcv_rate_v2, 15 min) y mismo cálculo que el checkout
   ((dólares × tasa).toFixed(2)), para que el cliente vea la misma cifra que luego paga.
   - [data-casio-bs-price]: tarjetas de colección, ficha y líneas del carrito (/cart). data-cents = precio en céntimos.
   - [data-casio-bs-total]: total del carrito; se actualiza con el evento del tema "cartcount:update" (Empire no
     repinta este bloque al cambiar cantidades).
   Una sola petición para toda la página (ninguna mientras la caché siga vigente). Si la tasa no llega, no se muestra
   nada: precios, carrito y botones de pago no dependen de esto. Settings globales "Precios en bolívares". */
(() => {
  if (window.casioBsPrices) return;
  window.casioBsPrices = true;

  const STORAGE_KEY = 'custom_checkout_bcv_rate_v2';
  const TTL = 15 * 60 * 1000;
  let ratePromise = null;
  let failedAt = 0;

  const readCache = () => {
    try {
      const item = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (item && Date.now() <= item.expiry && Number(item.value) > 0) return Number(item.value);
    } catch (e) {}
    return null;
  };

  const writeCache = (rate) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ value: rate, expiry: Date.now() + TTL }));
    } catch (e) {}
  };

  const getRate = (url) => {
    const cached = readCache();
    if (cached) return Promise.resolve(cached);
    if (Date.now() - failedAt < 60000) return Promise.resolve(null);
    if (!ratePromise) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      ratePromise = fetch(url, { method: 'GET', cache: 'no-store', credentials: 'omit', signal: controller.signal })
        .then((response) => (response.ok ? response.json() : null))
        .then((data) => {
          const rate = Number(data && data.rate);
          if (rate > 0) { writeCache(rate); return rate; }
          failedAt = Date.now();
          return null;
        })
        .catch(() => { failedAt = Date.now(); return null; })
        .finally(() => { clearTimeout(timeout); ratePromise = null; });
    }
    return ratePromise;
  };

  const bs = (cents, rate) => `Bs. ${Number(((Number(cents) / 100) * rate).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

  let filling = false;
  const fill = async () => {
    const pending = document.querySelectorAll('[data-casio-bs-price]:not([data-bs-done]), [data-casio-bs-total]:not([data-bs-done])');
    if (!pending.length || filling) return;
    const url = pending[0].dataset.rateUrl;
    if (!url) return;
    filling = true;
    const rate = await getRate(url);
    filling = false;
    if (!rate) return;

    document.querySelectorAll('[data-casio-bs-price]:not([data-bs-done])').forEach((el) => {
      if (Number(el.dataset.cents) > 0) el.textContent = (el.dataset.template || '[monto]').replace('[monto]', bs(el.dataset.cents, rate));
      el.setAttribute('data-bs-done', '');
    });

    document.querySelectorAll('[data-casio-bs-total]:not([data-bs-done])').forEach((row) => {
      const amount = row.querySelector('[data-casio-bs-amount]');
      if (amount && Number(row.dataset.cents) > 0) amount.textContent = bs(row.dataset.cents, rate);
      const note = row.querySelector('[data-casio-bs-rate]');
      if (note) note.textContent = (note.dataset.template || '').replace('[tasa]', String(rate));
      row.hidden = !(Number(row.dataset.cents) > 0);
      row.setAttribute('data-bs-done', '');
    });
  };

  let queued = false;
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; fill(); });
  };

  const start = () => {
    fill();
    /* El carrito (/cart) rehace sus líneas con morphdom: cambia data-cents o quita data-bs-done; las colecciones
       añaden tarjetas al filtrar. Se agrupa todo en un repaso por fotograma. */
    new MutationObserver((mutations) => {
      let changed = false;
      for (const m of mutations) {
        if (m.type === 'attributes') {
          if (m.attributeName === 'data-cents') m.target.removeAttribute('data-bs-done');
          if (!m.target.hasAttribute('data-bs-done')) changed = true;
        } else if (m.addedNodes.length) changed = true;
      }
      if (changed) queue();
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-cents', 'data-bs-done'] });
  };

  /* Carrito: Empire avisa con el carrito nuevo tras cada cambio de cantidad. */
  window.addEventListener('cartcount:update', (event) => {
    const cart = event.detail;
    if (!cart || typeof cart.total_price === 'undefined') return;
    document.querySelectorAll('[data-casio-bs-total]').forEach((row) => row.setAttribute('data-cents', cart.total_price));
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
